import React, { PropsWithChildren, useState } from 'react';
import {
  Modal,
  Nav,
  ModalBody,
  NavItem,
  Container,
  Row,
  Col,
  ModalFooter,
  Button,
  Collapse,
  Table,
  Badge,
} from 'reactstrap';
import { TabContent, TabNavLink, TabContainer } from '../../unsw-tabs';
import { useModal } from './ModalContext';

export const ModalTableRow = ({
  text,
  answer,
}: {
  text: string;
  answer: string | string[];
}) => (
  <tr>
    <td>{text}</td>
    <td>
      <ul className="list-unstyled">
        {Array.isArray(answer)
          ? answer.map((a, i) => <li key={i}>{a}</li>)
          : answer}
      </ul>
    </td>
  </tr>
);

const ResultTable = ({ children }: PropsWithChildren<{}>) => (
  <Table size="sm" bordered className="mb-0" color="info">
    <thead>
      <tr>
        <th>Question</th>
        <th>Answer</th>
      </tr>
    </thead>
    <tbody>{children}</tbody>
  </Table>
);

export const ModalSubTab = ({
  children,
  title,
}: PropsWithChildren<{ title: string }>) => {
  const [state, setState] = useState(false);
  return (
    <Row noGutters>
      <Col xs={12}>
        <Button
          size="sm"
          block
          className="rounded-0 border-top-0"
          color="info"
          outline
          onClick={() => setState(!state)}>
          {title}
        </Button>
      </Col>
      <Col>
        <Collapse isOpen={state}>
          <ResultTable>{children}</ResultTable>
        </Collapse>
      </Col>
    </Row>
  );
};

export const ModalTab = ({
  title,
  children,
}: PropsWithChildren<{ title: string }>) => {
  const [state, setState] = useState(false);
  return (
    <Row noGutters>
      <Button
        color="info"
        block
        className="rounded-0"
        size="lg"
        onClick={() => setState(!state)}>
        {title}
      </Button>
      <Col>
        <Collapse isOpen={state}>{children}</Collapse>
      </Col>
    </Row>
  );
};

export const SingleFieldSection = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <Row>
    <Col className="text-center lead">
      <span>
        <strong>{label}</strong>
        <Badge>{value}</Badge>
      </span>
    </Col>
  </Row>
);

export const DashboardModalSidebar = ({ children }: PropsWithChildren<{}>) => (
  <div className="col d-flex flex-column overflow-auto border-left">
    {children}
  </div>
);

const TabNavLinkItem = ({ tabId, label }: { tabId: string; label: string }) => (
  <NavItem>
    <TabNavLink tabId={tabId}>
      <Badge>{label}</Badge>
    </TabNavLink>
  </NavItem>
);

export const DashboardModalTabContent = ({
  children,
  links,
}: PropsWithChildren<{ links: { tabId: string; label: string }[] }>) => (
  <Col xs={8} className="d-flex flex-column align-self-start">
    <Nav tabs className="modal-header-tabs">
      {links.map(link => (
        <TabNavLinkItem
          key={link.tabId}
          tabId={link.tabId}
          label={link.label}
        />
      ))}
    </Nav>
    <TabContent>{children}</TabContent>
  </Col>
);

export const DashboardModal = ({ children }: PropsWithChildren<{}>) => {
  const { isOpen, close } = useModal();
  return (
    <Modal isOpen={isOpen} size="lg" scrollable toggle={() => close()}>
      <TabContainer>
        <ModalBody>
          <Container>
            <div className="d-flex" style={{ height: '80vh' }}>
              {children}
            </div>
          </Container>
        </ModalBody>
      </TabContainer>
      <ModalFooter>
        <Button onClick={() => close()} color="primary">
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { default as ModalProvider } from './ModalProvider';
export * from './ModalContext';
